import React, { useEffect, useState } from "react";
import { Dimensions, ScrollView, StyleSheet, View } from "react-native";
import { MD3Theme, useTheme } from "react-native-paper";
import Markdown from "react-native-markdown-display";
import { Text } from "../../../utils/fontsLoader";
import { ApolloQueryResult } from "@apollo/client";
import { Subscription } from "zen-observable-ts";
import Queries from "../../../api/queries";
import { OiqiaQIcon } from "../../../components/Icons";
import { SafeAreaView } from "react-native-safe-area-context";

const rules = {
    text: (node, children, parent, styles, inheritedStyles = {}) =>
        <Text key={node.key} style={[styles.text, inheritedStyles]}>
            {node.content}
        </Text>,
};

interface FindUsInterface {
    findUs: string;
}

export default function FindUs() {
    const theme = useTheme();
    const styles = styleGen(theme);
    const size = Dimensions.get("screen").height / 10;
    const [findUsData, setFindUsData] = useState<FindUsInterface>({ findUs: "" });
    const queries = new Queries();

    useEffect(() => {
        let findUsDataSubscription: Subscription;

        async function subscribeToFindUs() {
            try {
                const lang = "fr";
                const termsObservable = await queries.getFindUsByLang(lang);
                findUsDataSubscription = termsObservable.subscribe({
                    next(response: ApolloQueryResult<{ getFindUsByLang: string }>) {
                        setFindUsData({ findUs: response.data.getFindUsByLang });
                    },
                    error(err) {
                        console.error("Error fetching terms data:", err);
                    }
                });
            } catch (error) {
                console.error("Error setting up terms subscription:", error);
            }
        }

        subscribeToFindUs();

        // Cleanup subscription on component unmount
        return () => {
            findUsDataSubscription?.unsubscribe();
        };
    }, []);

    return (
        <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
            <ScrollView
                contentInsetAdjustmentBehavior="automatic"
                style={styles.container}>
                <View style={styles.subContainer}>
                    <Markdown
                        style={{
                            textgroup: { marginVertical: 10, },
                            bullet_list_icon: { marginVertical: 10, },
                            heading1: {
                                fontSize: 24,
                                textDecorationLine: "underline",
                                alignSelf: "center",
                                textAlign: "center"
                            },
                            heading2: {
                                fontSize: 18,
                                textDecorationLine: "underline",
                            },
                            heading3: {
                                fontSize: 16,
                            },
                            heading4: {
                                fontSize: 13,
                            },
                            heading5: {
                                fontSize: 11,
                            },
                            heading6: {
                                fontSize: 9,
                            },
                            strong: { fontFamily: "NotoSans-Bold" },
                            em: { fontFamily: "NotoSans-RegularItalic" },
                            link: { color: "blue" },
                        }}
                        rules={rules}
                    >
                        {findUsData?.findUs}
                    </Markdown>
                    <OiqiaQIcon width={size} height={size} />
                </View>
            </ScrollView>
        </SafeAreaView>
    );
}

const styleGen = (theme: MD3Theme) => StyleSheet.create({
    container: {
        backgroundColor: theme.colors.background,
        flex: 1,
    },
    subContainer: {
        margin: 20,
        gap: 20,
        alignItems: "center"
    }
});
